import axios from 'axios';
import { getTokenCookie, setTokenCookie } from './session';

const urlApi = process.env.REACT_APP_API_ENDPOINT
const tenantId = window.location.host.split(':')[0].split('.')[0];

const api_POST = (endpoint, obj, nao_valida_token) => {

  const promise = new Promise((resolve, reject) => {

    if (nao_valida_token !== undefined) {
      var token = getTokenCookie();
      var now = new Date();
      var expiration = new Date(token.expiration);
      if (expiration < now) {
        token.expired = true;
        setTokenCookie(token)
        window.location.reload();
        resolve(null);
      }
    }

    try {
      const urlComplete = urlApi + endpoint;
      const headers = { headers: { 'Content-Type': 'application/json', 'tenantId': tenantId } };
      return axios.post(urlComplete, JSON.stringify(obj), headers)
        .then(result => {
          var newResult = {
            status: result.status,
            message: result.message,
            data: result.data,
            headers: result.headers
          }
          resolve(newResult);
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 401 || error.response.status === 403) {
              token.expired = true;
              setTokenCookie(token)
              window.location.reload();
              resolve(null);
            }

            var message = "";
            if (error.response.data)
              message = error.response.data;
            else
              message = "Erro inesperado";

            var newError = {
              status: error.response.data.status,
              message: message
            }
            resolve(newError);
          }
          else {
            var result = {
              status: 500,
              message: "Erro ao conectar com api."
            }
            resolve(result);
          }
        });
    }
    catch (error) {
      var result = {
        status: 500,
        message: "Erro no servidor."
      }
      resolve(result);
    }
  });

  return promise;
};

const api_POST_File = (endpoint, obj, nao_valida_token) => {

  const promise = new Promise((resolve, reject) => {
    try {
      const urlComplete = urlApi + endpoint;
      const headers = { headers: { 'Content-Type': "multipart/form-data", "Mime-Type": "multipart/form-data", 'tenantId': tenantId } };
      return axios.post(urlComplete, obj, headers)
        .then(result => {
          var newResult = {
            status: result.status,
            message: result.message,
            data: result.data,
            headers: result.headers
          }
          resolve(newResult);
        })
        .catch(function (error) {
          if (error.response) {
            var message = "";
            if (error.response.data)
              message = error.response.data;

            var newError = {
              status: error.response.status,
              message: message
            }
            resolve(newError);
          }
          else {
            var result = {
              status: 501,
              message: "Erro ao conectar com api."
            }
            resolve(result);
          }
        });

    }
    catch (error) {
      var result = {
        status: 501,
        message: "Erro no servidor."
      }
      resolve(result);
    }

  });

  return promise;
};

const api_PUT = (endpoint, obj, nao_valida_token) => {

  const promise = new Promise((resolve, reject) => {

    if (nao_valida_token !== undefined) {
      var token = getTokenCookie();
      var now = new Date();
      var expiration = new Date(token.expiration);
      if (expiration < now) {
        token.expired = true;
        setTokenCookie(token)
        window.location.reload();
        resolve(null);
      }
    }
    try {
      const urlComplete = urlApi + endpoint;
      const headers = { headers: { 'Content-Type': 'application/json', 'tenantId': tenantId } };
      return axios.put(urlComplete, JSON.stringify(obj), headers)
        .then(result => {
          var newResult = {
            status: result.status,
            message: result.message,
            data: result.data,
            headers: result.headers
          }
          resolve(newResult);
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 401 || error.response.status === 403) {
              token.expired = true;
              setTokenCookie(token)
              window.location.reload();
              resolve(null);
            }

            var message = "";
            if (error.response.data)
              message = error.response.data;
            else
              message = "Erro inesperado";

            var newError = {
              status: error.response.data.status,
              message: message
            }
            resolve(newError);
          }
          else {
            var result = {
              status: 500,
              message: "Erro ao conectar com api."
            }
            resolve(result);
          }
        });

    }
    catch (error) {
      var result = {
        status: 500,
        message: "Erro no servidor."
      }
      resolve(result);
    }

  });

  return promise;
};

const api_DELETE = (endpoint, obj, nao_valida_token) => {

  const promise = new Promise((resolve, reject) => {

    if (nao_valida_token !== undefined) {
      var token = getTokenCookie();
      var now = new Date();
      var expiration = new Date(token.expiration);
      if (expiration < now) {
        token.expired = true;
        setTokenCookie(token)
        window.location.reload();
        resolve(null);
      }
    }
    try {
      const urlComplete = urlApi + endpoint;
      const headers = { headers: { 'Content-Type': 'application/json', 'tenantId': tenantId } };
      return axios.delete(urlComplete, JSON.stringify(obj), headers)
        .then(result => {
          var newResult = {
            status: result.status,
            message: result.message,
            data: result.data,
            headers: result.headers
          }
          resolve(newResult);
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 401 || error.response.status === 403) {
              token.expired = true;
              setTokenCookie(token)
              window.location.reload();
              resolve(null);
            }

            var message = "";
            if (error.response.data)
              message = error.response.data;
            else
              message = "Erro inesperado";

            var newError = {
              status: error.response.data.status,
              message: message
            }
            resolve(newError);
          }
          else {
            var result = {
              status: 500,
              message: "Erro ao conectar com api."
            }
            resolve(result);
          }
        });

    }
    catch (error) {
      var result = {
        status: 500,
        message: "Erro no servidor."
      }
      resolve(result);
    }

  });

  return promise;
};

const api_GET = (endpoint, nao_valida_token) => {

  const promise = new Promise((resolve, reject) => {

    if (nao_valida_token !== undefined) {
      var token = getTokenCookie();
      var now = new Date();
      var expiration = new Date(token.expiration);
      if (expiration < now) {
        token.expired = true;
        setTokenCookie(token)
        window.location.reload();
        resolve(null);
      }
    }
    try {
      const urlComplete = urlApi + endpoint;
      const headers = { headers: { 'tenantId': tenantId } };
      return axios.get(urlComplete, headers)
        .then(result => {
          let newResult = {
            status: result.status,
            data: result.data,
            headers: result.headers
          }
          resolve(newResult);
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 401 || error.response.status === 403) {
              token.expired = true;
              setTokenCookie(token)
              window.location.reload();
              return;
            }

            let message = "";
            if (error.response.data)
              message = error.response.data;
            else
              message = "Erro inesperado";

            let newError = {
              status: error.response.data.status,
              message: message
            }
            resolve(newError);
          }
          else {
            let result = {
              status: 500,
              message: "Erro ao conectar com a api."
            }
            resolve(result);
          }
        });

    }
    catch (error) {
      let result = {
        status: 500,
        message: "Erro no servidor."
      }
      resolve(result);
    }
  });

  return promise;

};

const api_GETExternal = (endpoint) => {

  const promise = new Promise((resolve, reject) => {

    try {
      return axios.get(endpoint)
        .then(result => {
          let newResult = {
            status: result.status,
            data: result.data,
            headers: result.headers
          }
          resolve(newResult);
        })
        .catch(function (error) {
          if (error.response) {
            if (error.response.status === 401 || error.response.status === 403) {
              window.location.reload();
              return;
            }

            let message = "";
            if (error.response.data.message)
              message = error.response.data.message;
            else
              message = "Erro inesperado";

            let newError = {
              status: error.response.data.status,
              message: message
            }
            resolve(newError);
          }
          else {
            let result = {
              status: 500,
              message: "Erro ao conectar com a api."
            }
            resolve(result);
          }
        });

    } catch (error) {
      let result = {
        status: 500,
        message: "Erro no servidor."
      }
      resolve(result);
    }

  });

  return promise;

};

export { api_POST, api_PUT, api_DELETE, api_GET, api_GETExternal, api_POST_File };